import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import defaultImage from "../Component/img/event1.jfif";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

const AllSports = () => {
  const [sports, setSports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSports = async () => {
      try {
        const response = await axios.get(`${BASE_URL}getAllSport`);
        console.log("API Response:", response);
        if (response.data.sports) {
          setSports(response.data.sports);
        } else {
          setError("Failed to fetch sports");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching sports:", error);
        setError("Error fetching sports");
        setLoading(false);
      }
    };
    fetchSports();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <span className="loader"></span>
        <p className="ms-3">Loading Content...</p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <>

<Helmet>
                <link rel="canonical" href="https://evventoz.com/sports" />
                <title>All Sports</title>
              </Helmet>

      <NavbarVisitor />

      <div className="container ">
        <div className="row mt-3">
          <div className="col">
            <h2 className="text-start">All Sports</h2>
          </div>
        </div>

        <div className="row g-4 mb-5">
          {sports.map((sport) => (
            <div key={sport.id} className="col-md-3 col-6">
              <Link to={`/${sport.sport_slug}/sport`} className="event-card-link">
                <div className="event-card">
                  <img
                    src={
                      sport.eventbanner
                        ? `${IMAGE_URL}sportFiles/${sport.eventbanner}`
                        : defaultImage
                    }
                    alt={sport.sport_name}
                    className="img-fluid eventimg"
                  />
                  <div className="event-details text-start p-1">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className="badge bg-gradient-primary etype">
                        {sport.sport_frequency || "N/A"}
                      </span>
                      <span className="ft-tags">
                        {new Date(
                          sport.sport_start_date
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "2-digit",
                        })}
                      </span>
                    </div>
                    <h4 className="ft-event">{sport.sport_name}</h4>
                    <div>{sport.organised_by}</div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AllSports;
